import { atom, RecoilState } from 'recoil';


export const rightsidePanel_isOpen: RecoilState<boolean> =
  atom<boolean>({
    key: 'rightside-panel-is-open',
    default: false
  });

